import EA from '../helpers/init';

export default EA.Methods.heroLoadAnim = ($this) => {
    const heroInner = $this.querySelector('.hero-inner');
    const heroHistoryTitle = $this.querySelector('.hero-history-title');
    let bgImg = $this.querySelector('.bg-wrapper');

    if(!bgImg) {
        bgImg = $this.querySelector('.swiper');
    }

    window.addEventListener('load', () => {
        setTimeout(() => {
            if(bgImg) bgImg.classList.add('show');
            if(heroInner) heroInner.classList.add('show');
            if(heroHistoryTitle) heroHistoryTitle.classList.add('show');
        }, 300);
    });
};